module.exports = __webpack_public_path__ + "media/customizations/creekhavenlife/back-11495ef8327f8135b3af5103b9598fc0.jpg";